<template>
    <div>
        {{dateValue}}
    </div>
</template>

<script>
    import DateUtil from "../utils/DateUtil";

    export default {
        name: 'DateRenderer',
        props: ['document', 'field'],
        data () {
            return {
                model: webase.model
            }
        },
        computed: {
            dateValue() {
                let time = Date.parse(this.document[this.field.index])
                let date = new Date()
                date.setTime(time)
                return new DateUtil().formatDate(date)
            }
        }
    }
</script>

<style>

</style>
